import { AxiosInstance } from 'axios'


interface AddressValidationConfig{
    axios: AxiosInstance,
    endpoints: {
        validateAddress:string,
        [others: string]: any
    },
    [others: string]: any
}


export default function(config:AddressValidationConfig){

    const initialState = {
        axios: config.axios,
        endpoint: config.endpoints.validateAddress,
        potentialAddresses: null,
        addressNotFound: false,
        ignoreErrors: false,
        checkedUnit:null,
        checkedStreetNumber:null,
        checkedStreetName:null,
        checkedSuburb:null,
        fields:null
    }

    
    return function(state = initialState, action){

        switch(action.type){

            //
            case "SUCCEED_WITH_ADDRESS":
                return ({
                    ...state,
                    potentialAddresses: null,
                    addressNotFound: false,
                    ignoreErrors: false
                })

            //
            case "CHECK_AGAINST_ADDRESS":
                return {
                    ...state,
                    checkedUnit: action.unitNumber,
                    checkedStreetNumber: action.streetNumber,
                    checkedStreetName: action.streetName,
                    checkedSuburb: action.suburb
                }

            
            //
            case "SUPPLY_POTENTIAL_ADDRESSES":
                return {
                    ...state,
                    potentialAddresses: action.addresses,
                    addressNotFound: false,
                    ignoreErrors: false,
                    fields: action.fields
                }
            
            //
            case "CLEAR_POTENTIAL_ADDRESSES":
                return {
                    ...state,
                    potentialAddresses: null,
                    ignoreErrors: false,
                    fields: null
                }
            
            //
            case "IGNORE_ADDRESSES":
                return {
                    ...state,
                    potentialAddresses: null,
                    addressNotFound: true,
                    ignoreErrors: true,
                    fields: null
                }

            //
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/address-validation/address-validation-reducer.ts